var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer"},[_c('img',{attrs:{"src":require("@/assets/img/icons/circle_timer_icon.svg"),"alt":"Circle"}}),_c('div',{staticClass:"seconds"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }